import { cn } from '@/lib/utils';
import { Button } from './button';

function EmptyState({
  icon: Icon,
  title = 'No data found',
  description,
  action,
  actionLabel,
  onAction,
  className,
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-muted/30 px-6 py-16 text-center',
        className
      )}
    >
      {Icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
          <Icon className="h-7 w-7 text-muted-foreground" />
        </div>
      )}
      <h3 className="font-display text-lg font-semibold text-foreground">{title}</h3>
      {description && <p className="mt-2 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {(action || onAction) && (
        <div className="mt-6">{action || <Button onClick={onAction}>{actionLabel}</Button>}</div>
      )}
    </div>
  );
}

export { EmptyState };
